import { createSlice } from '@reduxjs/toolkit';
import { scheduledForms } from 'locale/es';
import ScheduledFormsService from 'services/ScheduledFormsService';
import { toast } from './notificationReducer';

const initialState = { data: [], loading: false, error: null };

const scheduledFormSlice = createSlice({
  name: 'scheduledForm',
  initialState,
  reducers: {
    setScheduledForm(state, action) {
      const { data } = action.payload;
      return { ...state, data, loading: false, error: null };
    },
    updateScheduledForm(state, action) {
      const updatedState = state.data.map((form) =>
        form.id !== action.payload.id ? form : action.payload
      );

      return { ...state, data: updatedState, loading: false, error: null };
    },
    setScheduledFormLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setScheduledFormError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetScheduledFormState(state, action) {
      return initialState;
    },
  },
});

export const {
  setScheduledForm,
  updateScheduledForm,
  setScheduledFormByPatient,
  setScheduledFormLoading,
  setScheduledFormError,
  resetScheduledFormState,
} = scheduledFormSlice.actions;

export const initializeScheduledForms = (centerId) => {
  return async (dispatch) => {
    try {
      dispatch(setScheduledFormLoading());

      const { data } = await ScheduledFormsService.getAll(centerId);
      dispatch(setScheduledForm({ data }));
    } catch (error) {
      console.error(error);
      dispatch(
        setScheduledFormError({
          message: error.message,
          status: error.response?.status,
        })
      );
      dispatch(toast(scheduledForms.LOADING_ERROR, 'error'));
    }
  };
};

export const createScheduledFormAction = (formObj) => {
  return async (dispatch, getState) => {
    try {
      const { data: currentData } = getState().scheduledForm;
      const { data } = await ScheduledFormsService.create(formObj);
      dispatch(setScheduledForm({ data: [...currentData, data] }));
      dispatch(toast(scheduledForms.CREATED, 'success'));
    } catch (error) {
      console.error(error);
      dispatch(
        setScheduledFormError({
          message: error.message,
          status: error.response?.status,
        })
      );
      throw error;
    }
  };
};

export const updateScheduledFormAction = (updatedForm, formId) => {
  return async (dispatch, getState) => {
    try {
      const { data } = await ScheduledFormsService.update(updatedForm, formId);
      const updateData = getState().scheduledForm.data.map((form) =>
        form.id !== updatedForm.id ? form : updatedForm
      );

      dispatch(setScheduledForm({ data: updateData }));
      dispatch(toast(scheduledForms.EDITED, 'success'));
    } catch (error) {
      console.error(error);
      dispatch(
        setScheduledFormError({
          message: error.message,
          status: error.response?.status,
        })
      );
      throw error;
    }
  };
};

export const deleteScheduledFormAction = (formId) => {
  return async (dispatch, getState) => {
    try {
      const prevState = getState().scheduledForm.data;
      const newState = prevState.filter((form) => form.id !== formId);

      const updateData = Array.isArray(newState) ? newState : [];

      const { data } = await ScheduledFormsService.deleteScheduledForm(formId);
      dispatch(setScheduledForm({ data: updateData }));
      dispatch(toast(scheduledForms.DELETED, 'success'));
    } catch (error) {
      console.error(error);
      dispatch(
        setScheduledFormError({
          message: error.message,
          status: error.response?.status,
        })
      );
      dispatch(toast(scheduledForms.DELETED_ERROR, 'error'));
    }
  };
};

export default scheduledFormSlice.reducer;

